module.exports = __webpack_public_path__ + "assets/img/L-AK-IC.f2fa9448.png";